// extracted by mini-css-extract-plugin
module.exports = {"container":"Work_container__3fcQP","header":"Work_header__JNqSj","gallery":"Work_gallery__3umim","homeLink":"Work_homeLink__1jdV7"};